import jwt_decode, { JwtPayload } from "jwt-decode";

export const isTokenExpired = () => {
  var loggedInUserObj = JSON.parse(localStorage.getItem("loggedInUserObj"));
  if (loggedInUserObj == null) {
    return 0;
  } else {
    const decode = jwt_decode<JwtPayload>(loggedInUserObj.token);
    if (Date.now() >= decode.exp * 1000) {
      return 1;
    } else {
      return 0;
    }
  }
};
